import produce from "immer";
import {
  GET_PORTFOLIO_SIMULATION_SETTINGS_REQUEST,
  GET_PORTFOLIO_SIMULATION_SETTINGS_SUCCESS,
  GET_PORTFOLIO_SIMULATION_SETTINGS_ERROR,
  UPDATE_PORTFOLIO_SIMULATION_SETTINGS_REQUEST,
  UPDATE_PORTFOLIO_SIMULATION_SETTINGS_SUCCESS,
  UPDATE_PORTFOLIO_SIMULATION_SETTINGS_ERROR,
} from "../types";

const initialState = {
  settings: null, // { constraints: [...] } — null until first fetch
  isFetching: false,
  isUpdating: false,
  error: null,
};

export default function portfolioSimulationSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PORTFOLIO_SIMULATION_SETTINGS_REQUEST:
      return produce(state, (d) => {
        d.isFetching = true;
        d.error = null;
      });
    case GET_PORTFOLIO_SIMULATION_SETTINGS_SUCCESS:
      return produce(state, (d) => {
        d.isFetching = false;
        d.settings = action.payload;
      });
    case GET_PORTFOLIO_SIMULATION_SETTINGS_ERROR:
      return produce(state, (d) => {
        d.isFetching = false;
        d.error = action.payload;
      });
    case UPDATE_PORTFOLIO_SIMULATION_SETTINGS_REQUEST:
      return produce(state, (d) => {
        d.isUpdating = true;
        d.error = null;
      });
    case UPDATE_PORTFOLIO_SIMULATION_SETTINGS_SUCCESS:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.settings = action.payload;
      });
    case UPDATE_PORTFOLIO_SIMULATION_SETTINGS_ERROR:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.error = action.payload;
      });
    default:
      return state;
  }
}
